import type { MetricStat } from '../types';

const getMockEngagementStats = (): MetricStat[] => [
    {
        id: 'activation',
        label: 'Activation rate',
        value: '64%',
        hint: 'First successful workflow',
        tone: 'neutral',
        iconKey: 'activation',
    },
    {
        id: 'ttv',
        label: 'Time-to-value',
        value: '2.4 d',
        hint: 'Signup → first value',
        tone: 'positive',
        iconKey: 'timeToValue',
    },
    {
        id: 'steps',
        label: 'Steps in July',
        value: '182K',
        hint: '+61% over 6 months',
        tone: 'positive',
        iconKey: 'steps',
    },
    {
        id: 'workflows',
        label: 'Active workflows',
        value: '41',
        hint: 'With a run in July',
        tone: 'neutral',
        iconKey: 'workflows',
    },
    {
        id: 'tokens',
        label: 'LLM tokens',
        value: '9.2M',
        hint: 'July total',
        tone: 'neutral',
        iconKey: 'tokens',
    },
];

export default getMockEngagementStats;
